import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import { bootstrapAuthHeaders } from "@/lib/api";
import App from "@/App";

// Re-apply Authorization header from stored token before any axios call mounts.
bootstrapAuthHeaders();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
